import { createAuth0, useAuth0 } from '@auth0/auth0-vue';
import type { App } from 'vue';
import { appConfig } from '../providers/config';
import { registerAuth0Client } from '../auth0/auth0-client-access';

export default {
  install(app: App) {
    const domain = appConfig.VITE_AUTH0_DOMAIN;
    const clientId = appConfig.VITE_AUTH0_CLIENT_ID;
    const audience = appConfig.VITE_AUTH0_AUDIENCE;

    if (!domain || !clientId) {
      console.error(
        '[Auth0] Missing configuration. Ensure VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID are set.',
      );
    }

    const auth0Plugin = createAuth0(
      {
        domain: domain ?? '',
        clientId: clientId ?? '',
        authorizationParams: {
          redirect_uri: `${window.location.origin}/auth/callback`,
          ...(audience && { audience }),
          scope: 'profile email phone offline_access',
        },
        cacheLocation: 'localstorage',
        // Enable refresh tokens for automatic token renewal
        // Note: Requires "Refresh Token Rotation" enabled in Auth0 Dashboard
        // and "offline_access" scope if using audience
        useRefreshTokens: true,
        // useRefreshTokensFallback: true,
        // todo - enable when available
      },
      {
        // The app owns /auth/callback explicitly so the callback page can
        // complete redirect handling before it asks the session store to sync.
        skipRedirectCallback: true,
      },
    );

    app.use(auth0Plugin);

    app.runWithContext(() => {
      registerAuth0Client(useAuth0());
    });
  },
};
